import { Row, Col, Typography } from 'antd'
import { t } from 'i18next'
import {
  MobilOperatorType,
  useBusinessCardOrderDetailMutation,
} from '@app/store/reducers/salaryCards/businessCardOrder.api'
import React from 'react'
import { DownloadBtnIco } from '@modules/CustomIcons'
import Icon from '@ant-design/icons'
import { FileDownload } from '@app/pages/Orders/businessCardOrder/feature/FileDownload'

const { Text } = Typography

export const RowItem = ({
  label,
  value,
  red = false,
  bottomBorder = true,
}: {
  label: React.ReactNode
  value: string | number | React.ReactNode
  red?: boolean
  bottomBorder?: boolean
}) => (
  <div className={`${bottomBorder ? 'rowBorderBottom' : ''} flexRow`}>
    <Text className="custom-text-color">{label}: </Text>
    <Text style={red ? { color: 'red' } : undefined}>{value}</Text>
  </div>
)

const OrderDetailModalMain = () => {
  const [_, { data: detailInformationList }] =
    useBusinessCardOrderDetailMutation({
      fixedCacheKey: 'businessCardOrderDetail',
    })

  const { cardHolder, front, back } = detailInformationList || {}

  return (
    <Row style={{ flexDirection: 'column', marginTop: '40px' }}>
      <Col span={24}>
        <Typography.Title style={{ fontSize: '16px' }}>
          {t('businessCardOrders.labels.cardHolderInfoTitle')}
        </Typography.Title>
      </Col>
      <Col span={24}>
        <Row
          justify="space-evenly"
          gutter={[32, 0]}
          style={{ marginBottom: '20px' }}
        >
          <Col md={8}>
            <div className="tabUserInfo">
              <RowItem
                label={t('businessCardOrders.labels.cardHolderFullName')}
                value={cardHolder?.cardHolderFullName}
              />
              <RowItem
                bottomBorder={false}
                label={
                  <>
                    {t('businessCardOrders.labels.phoneNumber')}{' '}
                    {cardHolder?.mobileOperatorName !==
                      MobilOperatorType.None && (
                      <>
                        (
                        <span style={{ color: '#015CD1' }}>
                          {MobilOperatorType[cardHolder?.mobileOperatorName]}
                        </span>
                        )
                      </>
                    )}
                  </>
                }
                value={cardHolder?.phoneNumber}
              />
            </div>
          </Col>

          <Col md={8}>
            <div className="tabUserInfo">
              <RowItem
                label={t('businessCardOrders.labels.pin')}
                value={cardHolder?.pin}
              />
              <RowItem
                bottomBorder={false}
                label={t('businessCardOrders.labels.serialTypeAndNo')}
                value={`${cardHolder?.serialType} ${cardHolder?.serialNo}`}
              />
            </div>
          </Col>

          <Col md={8}>
            {!!front && (
              <div className="tabUserInfo">
                <RowItem
                  bottomBorder={!!back || false}
                  label={
                    <FileDownload fileId={front.uid} title={t('businessCardOrders.idcard.frontFileName')} />
                  }
                  value={<Icon component={DownloadBtnIco} />}
                />
                {!!back && (
                  <RowItem
                    bottomBorder={false}
                    label={
                      <FileDownload
                        fileId={back.uid}
                        title={t('businessCardOrders.idcard.backFileName')}
                      />
                    }
                    value={<Icon component={DownloadBtnIco} />}
                  />
                )}
              </div>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default OrderDetailModalMain
